import React from 'react';
import PropTypes from 'prop-types';
import { BUTTON_IDS } from '../../reducers/ui/buttons';
import { connect } from 'react-redux';
import { forwardConversationToExperts, setTagOnForwardStatus, setTaggingActive, setShowTools } from '../../actions';
import {
  extractSelectedTicketIdFromState,
  getSelectedInboxTab,
  isSimplrTaggingAvailableForSelectedTicket,
  expertsForForwardingDropdownNextPageExist,
  getExpertsForForwardingDropdownList,
  getSelectedExpertForForForwardingDropdown,
} from '../../extractFromState';
import { FlexRow } from '../common/buttonsComponents';
import SearchDropDownAsync from 'components/DropDown/SearchDropDownAsync/SearchDropDownAsync';
import {
  asyncHydrateAvailableExpertsForForwardingDropdown,
  setSearchParamForForwardingDropdownAndLoad,
  setSelectedExpertForForwardingDropdownAndLoad,
  clearStateForForwardingDropdown,
} from 'actions/forwardToExpertActions';
import { showErrorPopup } from 'components/popups/ErrorPopup/ErrorPopup';
import { expertIsAvailable } from '../../util/util';
import { makeDisplayName } from '../../util/formatUtil';
import { DropDownContainer, ForwardToExpertWrapper, Button } from './ForwardToExpert.styles';

export class ForwardToExpert extends React.Component {
  static propTypes = {
    isButtonActive: PropTypes.bool.isRequired,
    setBtnActivity: PropTypes.func.isRequired,
  };

  state = {
    expertsForDropdownIsLoading: false,
  };

  onValueChange = async (inputValue) => {
    await this.props._setSearchParamForForwardingDropdownAndLoad(inputValue);
  };

  getOptions = () => {
    const expertData = this.props.expertsForForwardingDropdownList;

    return expertData.map((expert) => {
      const displayName = makeDisplayName({ id: expert.id, firstName: expert.firstName, lastName: expert.lastName });

      return {
        value: expert.id,
        label: displayName,
      };
    });
  };

  onValueChangedHandler = async (inputValue) => {
    if (inputValue) {
      await this.props._setSelectedExpertForForwardingDropdownAndLoad({
        id: inputValue.value,
        name: inputValue.label,
      });
    } else {
      this.props._clearStateForForwardingDropdown();
    }
  };

  hydrateAvailableExperts = async () => {
    await this.props._asyncHydrateAvailableExpertsForForwardingDropdown();
  };

  onOpen = async () => {
    this.setState({ expertsForDropdownIsLoading: true });
    this.props._clearStateForForwardingDropdown();
    await this.hydrateAvailableExperts();
    this.setState({ expertsForDropdownIsLoading: false });
  };

  onForwardButtonClick = async (selectedTicketId, selectedExpert, button, selectedInboxTab) => {
    let isExpertAvailable;
    // If a specific expert was chosen in the dropdown, check for availability
    if (selectedExpert && selectedExpert.name !== 'Any Expert') {
      try {
        isExpertAvailable = await expertIsAvailable(selectedExpert.id);
      } catch (err) {
        return showErrorPopup(err.message, 'Oops!');
      }
    }

    // If the user did not manually select an expert selectedExpert.name === 'Any Expert'
    // and selectedExpert.id will be undefined so the ticket will go into awaiting nomination
    if (isExpertAvailable || (selectedExpert && selectedExpert.name === 'Any Expert')) {
      this.props.onForwardClick(selectedTicketId, selectedExpert, button, selectedInboxTab);
    } else {
      this.props._clearStateForForwardingDropdown();

      return showErrorPopup('Selected expert is not available anymore!\n Please select another one!', 'Oops!');
    }
  };

  render() {
    const { allForwardBtn, escalateForwardBtn } = BUTTON_IDS;
    let button;
    if (this.props.selectedInboxTab === 'all') {
      button = allForwardBtn;
    } else {
      button = escalateForwardBtn;
    }

    const {
      selectedInboxTab,
      selectedTicketId,
      isButtonActive,
      setBtnActivity,
      taggingAvailable,
      _setTaggingActive,
      _setShowTools,
      _setTagOnForwardStatus,
      className,
      selectedExpertForForwardingDropdown,
      _expertsForForwardingDropdownNextPageExist,
    } = this.props;

    const selectedExpertId = selectedExpertForForwardingDropdown && selectedExpertForForwardingDropdown.id;
    const selectedExpert = {
      value: selectedExpertId,
      label: selectedExpertForForwardingDropdown && selectedExpertForForwardingDropdown.name,
    };

    return (
      <ForwardToExpertWrapper className={className}>
        <DropDownContainer>
          <SearchDropDownAsync
            label=""
            onLoad={this.hydrateAvailableExperts}
            onOpen={this.onOpen}
            nextPageExist={_expertsForForwardingDropdownNextPageExist}
            onInputChange={this.onValueChange}
            selectedId={selectedExpert}
            options={this.getOptions()}
            onChange={this.onValueChangedHandler}
            isLoading={this.state.expertsForDropdownIsLoading}
          />
        </DropDownContainer>
        <FlexRow>
          <Button
            buttonId={button}
            active={isButtonActive}
            disabled={!isButtonActive}
            clickAction={async () =>
              await this.onForwardButtonClick(
                selectedTicketId,
                selectedExpertForForwardingDropdown,
                button,
                selectedInboxTab
              )
            }
            setBtnActivity={setBtnActivity}
          >
            FORWARD
          </Button>
          {selectedInboxTab === 'all' && taggingAvailable && (
            <Button
              active={isButtonActive}
              disabled={!isButtonActive}
              clickAction={() => {
                _setTagOnForwardStatus();
                _setTaggingActive(true);
                _setShowTools(true);
              }}
              setBtnActivity={setBtnActivity}
            >
              TAG
            </Button>
          )}
        </FlexRow>
      </ForwardToExpertWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTicketId: extractSelectedTicketIdFromState(state),
  selectedInboxTab: getSelectedInboxTab(state),
  taggingAvailable: isSimplrTaggingAvailableForSelectedTicket(state),
  expertsForForwardingDropdownList: getExpertsForForwardingDropdownList(state),
  _expertsForForwardingDropdownNextPageExist: expertsForForwardingDropdownNextPageExist(state),
  selectedExpertForForwardingDropdown: getSelectedExpertForForForwardingDropdown(state),
});

const mapDispatchToProps = (dispatch) => ({
  onForwardClick(conversationId, selectedExpert, buttonId, inboxTab) {
    dispatch(forwardConversationToExperts(conversationId, selectedExpert, buttonId, inboxTab));
  },
  _setTagOnForwardStatus() {
    dispatch(setTagOnForwardStatus(true));
  },
  _setTaggingActive(value) {
    dispatch(setTaggingActive(value));
  },
  _setShowTools(value) {
    dispatch(setShowTools(value));
  },
  _asyncHydrateAvailableExpertsForForwardingDropdown() {
    return dispatch(asyncHydrateAvailableExpertsForForwardingDropdown());
  },
  _setSearchParamForForwardingDropdownAndLoad(inputValue) {
    return dispatch(setSearchParamForForwardingDropdownAndLoad(inputValue));
  },
  _setSelectedExpertForForwardingDropdownAndLoad(inputValue) {
    return dispatch(setSelectedExpertForForwardingDropdownAndLoad(inputValue));
  },
  _clearStateForForwardingDropdown() {
    return dispatch(clearStateForForwardingDropdown());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ForwardToExpert);
